// extracted by mini-css-extract-plugin
export var completionBody = "_i4-2";
export var completionCard = "_i4-0";
export var completionFooter = "_i4-3";
export var completionTitle = "_i4-1";